import { Skeleton } from '@kiwicom/orbit-components';
import { useIntl } from 'react-intl';

import MyTripsPlaceholder from './MyTripsPlaceholder';
import InboxPlaceholder from './InboxPlaceholder';
import WalletPlaceholder from './WalletPlaceholder';
import PreferencesPlaceholder from './PreferencesPlaceholder';
import PriceAlertsPlaceholders from './PriceAlertsPlaceholder';
import GeneralPlaceholder from './GeneralPlaceholder';
import FareLocksPlaceholder from './FareLocksPlaceholder';
import ReferFriendPlaceholder from './ReferFriendPlaceholder';

type PlaceholderProps = {
  activeTab: string;
};

const getPlaceHolderContent = (activeTab: string) => {
  switch (activeTab) {
    case 'trips':
      return <MyTripsPlaceholder />;
    case 'inbox':
      return <InboxPlaceholder />;
    case 'locked-prices':
      return <FareLocksPlaceholder />;
    case 'price-alerts':
      return <PriceAlertsPlaceholders />;
    case 'wallet':
      return <WalletPlaceholder />;
    case 'refer-friend':
      return <ReferFriendPlaceholder />;
    case 'preferences':
      return <PreferencesPlaceholder />;
    default:
      return <GeneralPlaceholder />;
  }
};

const HomePagePlaceholder = ({ activeTab }: PlaceholderProps): JSX.Element => {
  const intl = useIntl();
  return (
    <>
      <Skeleton
        width="100%"
        height={75}
        dataTest="HomePageTabs-placeholder"
        title={intl.formatMessage({
          id: 'common.loading',
          defaultMessage: 'Loading',
        })}
      >
        <rect x="0" y="0" height="55" width="100%" />
      </Skeleton>
      {getPlaceHolderContent(activeTab)}
    </>
  );
};

export default HomePagePlaceholder;
